import React, { ReactNode } from 'react';
import { withLocalization, withLocalizationProps } from '../../context/Config';
import './DateViewer.less';

export type DateViewerProps = {
  children?: ReactNode;
  date?: string;
  locale?: string;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
};

const TDateViewer: React.FC<DateViewerProps & withLocalizationProps> = ({
  date,
  moment,
}) => {
  const month = moment(date).format('MMM D').toUpperCase();

  return (
    <div className="t-timViewerContainer">
      <div>
        <span>{month}</span>
      </div>
    </div>
  );
};

export default withLocalization(TDateViewer);
